/**
 * Crea entrada en agenda al agendar una visita de captación.
 * La tarea T4 · Cita (sin vencimiento) se asegura vía API (idempotente).
 */
export async function crearCitaCaptacionAgenda(api, { captacion, historial_data, agenteId }) {
  if (!captacion?.id || historial_data?.resultado !== 'cita' || !historial_data?.fecha_accion) {
    return { ok: false, skipped: true };
  }

  // Prioridad: agente de la captación (para que salga en su APP), luego el pasado, luego sesión.
  const agente = captacion.agente_id ?? agenteId ?? null;
  const nombreProp = [captacion.nombre, captacion.apellido].filter(Boolean).join(' ') || 'propietario';
  const fechaInicio = new Date(historial_data.fecha_accion).toISOString();
  const duracionH = historial_data.duracion_horas || 2;
  const fechaFin = new Date(new Date(fechaInicio).getTime() + duracionH * 3600 * 1000).toISOString();
  const tituloCap = `Captación — ${nombreProp}`;

  let extras = {};
  try {
    extras = (typeof captacion.datos_extras === 'object' && captacion.datos_extras !== null)
      ? captacion.datos_extras
      : JSON.parse(captacion.datos_extras || '{}');
  } catch {
    extras = {};
  }

  // Idempotente: cambiarEtapa ya puede haber creado la cita en servidor.
  try {
    const prev = await api.get(`/agenda/captacion/${captacion.id}`);
    const citas = prev?.data?.data || prev?.data || [];
    const activa = (Array.isArray(citas) ? citas : []).find((c) => {
      const est = String(c?.estado || '').toLowerCase();
      const tipo = String(c?.tipo || '').toLowerCase();
      return ['captacion', 'valoracion'].includes(tipo)
        && !['cancelada', 'cancelado', 'realizada', 'realizado'].includes(est);
    });
    if (activa?.id) {
      try {
        await api.post(`/tareas/captacion/${captacion.id}/ensure-cita`, {
          agenda_id: activa.id,
          agente_id: agente,
        });
      } catch (e) {
        console.error('[crearCitaCaptacionAgenda] ensure-cita (existente):', e?.message || e);
      }
      return { ok: true, agenda_id: activa.id, reused: true };
    }
  } catch (_) { /* seguir a crear */ }

  const agendaRes = await api.post('/agenda', {
    captacion_id: captacion.id,
    agente_id: agente,
    titulo: tituloCap,
    descripcion: historial_data.contenido || null,
    tipo: 'captacion',
    fecha_inicio: fechaInicio,
    fecha_fin: fechaFin,
    estado: 'pendiente',
    direccion: [
      captacion.calle,
      captacion.numero,
      captacion.poblacion || extras.poblacion || extras.domicilio_poblacion,
      extras.codigo_postal || extras.cp,
      extras.provincia || extras.domicilio_provincia,
    ].filter(Boolean).join(', ') || null,
  });
  const agendaId = agendaRes?.data?.data?.id || agendaRes?.data?.id || null;

  // Asegurar T4 aunque el hook de agenda falle o el deploy aún no lo tenga.
  try {
    await api.post(`/tareas/captacion/${captacion.id}/ensure-cita`, {
      agenda_id: agendaId,
      agente_id: agente,
    });
  } catch (e) {
    console.error('[crearCitaCaptacionAgenda] ensure-cita:', e?.message || e);
  }

  return { ok: true, agenda_id: agendaId };
}

export async function completarTareaActivaCaptacion(api, captacionId) {
  if (!captacionId) return;
  try {
    const res = await api.get(`/tareas/captacion/${captacionId}/activa`);
    const tarea = res.data?.tarea;
    if (tarea?.id) {
      await api.put(`/tareas/${tarea.id}/completar`, { resultado: 'Cita agendada' });
    }
  } catch {
    /* sin tarea activa */
  }
}
